<template>
  <div class="change-mobile-dialog">
    <el-dialog
      title="更改手机号码"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="mobileForm" label-width="120px" v-loading="loading">
        <el-form-item label="订单ID：">
          <span>{{ formData.id }}</span>
        </el-form-item>
        
        <el-form-item label="当前手机号：">
          <span>{{ formData.current_mobile }}</span>
        </el-form-item>
        
        <el-form-item label="新手机号：" prop="new_mobile">
          <el-input
            v-model="formData.new_mobile"
            placeholder="请输入新的手机号码"
            maxlength="11">
          </el-input>
        </el-form-item>
        
        <el-form-item label="确认手机号：" prop="confirm_mobile">
          <el-input
            v-model="formData.confirm_mobile"
            placeholder="请再次输入新的手机号码"
            maxlength="11">
          </el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ygbOrderChangePhone, ygbOrderInfo } from '@/api/member'

export default {
  name: 'ChangeMobile',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    // 自定义验证规则
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }
    
    const validateConfirmMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入手机号码'))
      } else if (value !== this.formData.new_mobile) {
        callback(new Error('两次输入的手机号码不一致'))
      } else {
        callback()
      }
    }
    
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      formData: {
        id: '',
        current_mobile: '',
        new_mobile: '',
        confirm_mobile: ''
      },
      rules: {
        new_mobile: [
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        confirm_mobile: [
          { required: true, validator: validateConfirmMobile, trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
      }
    }
  },
  methods: {
    async initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.formData = {
          id: this.rowData.id,
          current_mobile: this.rowData.mobile || '',
          new_mobile: '',
          confirm_mobile: ''
        }
        
        // 如果没有手机号信息，通过API获取订单详情
        if (!this.formData.current_mobile && this.rowData.id) {
          this.loading = true
          try {
            const response = await ygbOrderInfo({
              id: this.rowData.id,
              platform_type: 8
            })
            
            if (response && response.err_code === 0 && response.order) {
              this.formData.current_mobile = response.order.mobile || ''
            }
          } catch (error) {
            console.error('获取订单信息失败:', error)
            this.$message.error('获取订单信息失败')
          } finally {
            this.loading = false
          }
        }
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$refs.mobileForm.resetFields()
    },
    handleSubmit() {
      this.$refs.mobileForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            const response = await ygbOrderChangePhone({
              id: this.formData.id,
              mobile: this.formData.new_mobile
            })
            
            if (response.err_code === 0) {
              this.$message.success('手机号码修改成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(response.data?.err_msg || '修改手机号码失败')
            }
          } catch (error) {
            console.error('修改手机号码失败:', error)
            this.$message.error('修改手机号码失败，请稍后重试')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.change-mobile-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>